import React from 'react';
import { Box, Typography } from '@mui/material';
import { B2DSymboleIcon, FaOptionIcon } from '@europrocurement/l2d-icons';

import { faPhone, faEnvelope } from '@fortawesome/sharp-regular-svg-icons';
import { CustomAvatar } from '../CustomAvatar';

export const UserContact: React.FunctionComponent<{
    user: {
        firstName?: string | null | undefined;
        lastName?: string | null | undefined;
        idUserGie?: number | null | undefined;
    } | null;
    userIdentifier: string | null;
    role: string;
    mail?: string;
    phone?: string;
    badge?: string | undefined;
}> = function ({ user, userIdentifier, role, mail, phone, badge }) {
    const avatarContact = !userIdentifier ? (
        <B2DSymboleIcon style={{ maxHeight: '24px' }} />
    ) : (
        <CustomAvatar
            firstName={!userIdentifier && user && user.firstName ? user.firstName : undefined}
            lastName={!userIdentifier && user && user.lastName ? user.lastName : undefined}
            keycloakId={userIdentifier || undefined}
            src={mail}
            badge={badge}
        />
    );

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: 0.5,
                paddingBottom: 1,
                justifyContent: 'space-between',
                paddingLeft: 2,
                paddingRight: 2,
                alignItems: 'center',
                width: '100%',
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
                {avatarContact}

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography
                        variant="l2dh7"
                        fontWeight="bold"
                    >
                        {user?.firstName} {user?.lastName}
                    </Typography>
                    <Typography
                        variant="l2dcaption"
                        color="textSecondary"
                    >
                        {role}
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 3 }}>
                {mail && (
                    <Box
                        sx={{ cursor: 'pointer' }}
                        onClick={() => {
                            window.location.href = `mailto:${mail}`;
                        }}
                    >
                        <FaOptionIcon
                            icon={faEnvelope}
                            size="lg"
                            color="text.gris50"
                            tooltip={mail}
                        />
                    </Box>
                )}
                {phone && (
                    <Box
                        sx={{ cursor: 'pointer' }}
                        onClick={() => {
                            window.location.href = `tel:${phone}`;
                        }}
                    >
                        <FaOptionIcon
                            icon={faPhone}
                            size="lg"
                            color="text.gris50"
                            tooltip={phone}
                        />
                    </Box>
                )}
            </Box>
        </Box>
    );
};
